import Service from "../AuthService";

const ContactType = {
    getAllContactTypes() {
        return Service.get(`contact-types`);
    }
};

export default ContactType;
